import { StorageService } from 'services/StorageService';

export const STORAGE = new StorageService();

export const sessionStorageKeys = {
  PARTNER_PATH: 'partnerPath',
  SESSION: 'session',
  STATE: 'state'
};
